import { render, staticRenderFns } from "./BsTitle.vue?vue&type=template&id=4a07d67b&scoped=true&"
import script from "./BsTitle.vue?vue&type=script&lang=js&"
export * from "./BsTitle.vue?vue&type=script&lang=js&"
import style0 from "./BsTitle.vue?vue&type=style&index=0&id=4a07d67b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a07d67b",
  null
  
)

export default component.exports